import configs from '../config';
import { fetchWithTenant } from '../utils/apiClient';

const API_BASE_URL = `${configs.BACKEND_URL}/api/notifications`;

async function fetchJson(url, options) {
  const response = await fetchWithTenant(url, options);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || data.error || 'Request failed');
  }
  return response.json();
}

export async function getNotifications({
  page = 1,
  limit = 20,
  unreadOnly = false,
  type = null,
  priority = null
} = {}) {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    unreadOnly: unreadOnly.toString()
  });
  if (type) params.append('type', type);
  if (priority) params.append('priority', priority);

  return fetchJson(`${API_BASE_URL}/?${params.toString()}`);
}

export async function getUnreadCount() {
  return fetchJson(`${API_BASE_URL}/unread-count`);
}

export async function markAsRead(notificationId) {
  return fetchJson(`${API_BASE_URL}/${notificationId}/read`, { method: 'PATCH' });
}

export async function markAsUnread(notificationId) {
  return fetchJson(`${API_BASE_URL}/${notificationId}/unread`, { method: 'PATCH' });
}

export async function markAllAsRead() {
  return fetchJson(`${API_BASE_URL}/mark-all-read`, { method: 'PATCH' });
}

export async function deleteNotification(notificationId) {
  return fetchJson(`${API_BASE_URL}/${notificationId}`, { method: 'DELETE' });
}

export async function getNotificationConfig() {
  return fetchJson(`${API_BASE_URL}/config`);
}

export async function createTestNotification(testData) {
  return fetchJson(`${API_BASE_URL}/test`, {
    method: 'POST',
    body: JSON.stringify(testData),
  });
}

export async function getNotificationStats() {
  return fetchJson(`${API_BASE_URL}/stats`);
}

const notificationService = {
  getNotifications,
  getUnreadCount,
  markAsRead,
  markAsUnread,
  markAllAsRead,
  deleteNotification,
  getNotificationConfig,
  createTestNotification,
  getNotificationStats
};

export default notificationService;
